const SERVER = 'https://tommievercetti.com/api';

export default SERVER;